/** Expiry ends UI waiting, not a financial transaction. Late signed results are retained. */
export async function awaitWalletConfirmation<T>(pending: Promise<T>, options: {
  expiresAt: number; now(): number; expired(): void; late(result: T): Promise<void>;
}): Promise<T> {
  let expired = false, timer: ReturnType<typeof setTimeout> | undefined;
  const deadline = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => { expired = true; options.expired(); reject(new Error("wallet_request_expired")); },
      Math.max(0, Math.min(2_147_483_647, options.expiresAt - options.now())));
  });
  const observed = pending.then(async result => {
    if (expired) await options.late(result);
    return result;
  });
  try { return await Promise.race([observed, deadline]); }
  finally { clearTimeout(timer); }
}
